export const PAGE_PERMISSIONS = [
  { ScreenName: "/calendar", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/allquotes", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/quote_detail", AllowedUsers: ["Admin", "Semi-Admin"] },
  {
    ScreenName: "/earningsdashboard",
    AllowedUsers: ["Admin", "Contractor"],
  },
  {
    ScreenName: "/tippingdashboard",
    AllowedUsers: ["Admin", "Contractor"],
  },
  { ScreenName: "/invoicedata", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/receiptsdata", AllowedUsers: ["Admin", "Semi-Admin"] },
  {
    ScreenName: "/employeetimelog",
    AllowedUsers: ["Admin", "Semi-Admin", "Driver", "Helper"],
    Deny: ["Contractor"],
  },
  {
    ScreenName: "/employeebonusanddeductions",
    AllowedUsers: ["Admin", "Semi-Admin"],
  },
  {
    ScreenName: "/employeeview",
    AllowedUsers: ["Admin", "Semi-Admin", "Driver", "Helper"],
    Deny: ["Contractor"],
  },
  {
    ScreenName: "/contractorview",
    AllowedUsers: ["Admin", "Driver", "Helper"],
    Deny: ["Employee"],
  },
  { ScreenName: "/employeesummary", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/employeerates", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/jobreview", AllowedUsers: ["Admin", "Semi-Admin"] },
  {
    ScreenName: "/jobreviewmonthlystats",
    AllowedUsers: ["Admin", "Semi-Admin"],
  },
  { ScreenName: "/damageclaims", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/marketingscore", AllowedUsers: ["Admin", "Semi-Admin"] },
  {
    ScreenName: "/materialstemplatetype",
    AllowedUsers: ["Admin", "Semi-Admin"],
  },
  { ScreenName: "/materialslistprice", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/addressunit", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/storageprice", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/storagerecord", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/clients", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/support", AllowedUsers: ["Admin", "Semi-Admin"] },
  {
    ScreenName: "/myconversations",
    AllowedUsers: ["Admin", "Semi-Admin", "Driver", "Helper"],
  },
  { ScreenName: "/waconversations", AllowedUsers: ["Admin", "Semi-Admin"] },
  {
    ScreenName: "/blogarticle",
    AllowedUsers: ["Admin", "Semi-Admin", "Blog Admin"],
  },
  {
    ScreenName: "/blogauthor",
    AllowedUsers: ["Admin", "Semi-Admin", "Blog Admin"],
  },
  {
    ScreenName: "/contentlibrary",
    AllowedUsers: ["Admin", "Semi-Admin", "Blog Admin"],
  },
  { ScreenName: "/location", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/pages", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/userReview", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/user", AllowedUsers: ["Admin"] },
  { ScreenName: "/rates", AllowedUsers: ["Admin"] },
  { ScreenName: "/mover", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/moverrates", AllowedUsers: ["Admin"] },
  {
    ScreenName: "/moverunavailability",
    AllowedUsers: ["Admin", "Semi-Admin", "Driver", "Helper"],
  },
  { ScreenName: "/movertypes", AllowedUsers: ["Admin"] },
  { ScreenName: "/vantypes", AllowedUsers: ["Admin"] },
  { ScreenName: "/van", AllowedUsers: ["Admin"] },
  { ScreenName: "/discount", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/campaign", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/campaigndata", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/holiday", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/timeslot", AllowedUsers: ["Admin"] },
  { ScreenName: "/slots", AllowedUsers: ["Admin"] },
  { ScreenName: "/van_availability", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/largevans", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/systemconfiguration", AllowedUsers: ["Admin"] },
  { ScreenName: "/emailtemplate", AllowedUsers: ["Admin"] },
  { ScreenName: "/generaldata", AllowedUsers: ["Admin"] },
  { ScreenName: "/minimumcharge", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/bankholiday", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/recentjob", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/locationstats", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/locationmove", AllowedUsers: ["Admin", "Semi-Admin"] },
  { ScreenName: "/driverdashboard", AllowedUsers: ["Driver", "Helper"] },
  {
    ScreenName: "/mynotifications",
    AllowedUsers: ["Admin", "Semi-Admin", "Driver", "Helper"],
  },

  {
    ScreenName: "/servicequestions",
    AllowedUsers: ["Admin", "Semi-Admin", "Driver", "Helper"],
  },
  { ScreenName: "/materialsjobs", AllowedUsers: ["Admin", "Semi-Admin"] },
  {
    ScreenName: "/xml",
    AllowedUsers: ["Admin", "Semi-Admin"],
  },
  {
    ScreenName: "/SiteMap",
    AllowedUsers: ["Admin", "Semi-Admin"],
  },
  {
    ScreenName: "/generalinfo",
    AllowedUsers: ["Admin", "Semi-Admin"],
  },
  {
    ScreenName: "/productfaqs",
    AllowedUsers: ["Admin", "Semi-Admin"],
  },
  {
    ScreenName: "/products",
    AllowedUsers: ["Admin", "Semi-Admin"],
  },
  {
    ScreenName: "/productcategory",
    AllowedUsers: ["Admin", "Semi-Admin"],
  },
  {
    ScreenName: "/productreview",
    AllowedUsers: ["Admin", "Semi-Admin"],
  },
  {
    ScreenName: "/orders",
    AllowedUsers: ["Admin", "Semi-Admin"],
  },
  {
    ScreenName: "/customers",
    AllowedUsers: ["Admin", "Semi-Admin"],
  },
  {
    ScreenName: "/courtesylivescreen",
    AllowedUsers: ["Admin", "Semi-Admin"],
  },
  {
    ScreenName: "/warningsandperformanceissue",
    AllowedUsers: ["Admin", "Semi-Admin", "Driver", "Helper"],
  },
  {
    ScreenName: "/statisticmenu",
    AllowedUsers: ["Admin"],
  },
  {
    ScreenName: "/orderinvoice",
    AllowedUsers: ["Admin", "Semi-Admin"],
  }
  ,
  {
    ScreenName: "/financecategories",
    AllowedUsers: ["Admin", "Semi-Admin"],
  }
];

export function hasAccess(url: string, userRoles: string[]) {
  const path: any = url.split("?")[0];
  url = path;
  if (url.includes("quote_detail")) url = "/quote_detail";

  const permission = PAGE_PERMISSIONS.find((p) => p.ScreenName === url);
  if (!permission) return false;

  // Deny has highest priority
  if (permission.Deny?.some((role) => userRoles.includes(role))) {
    return false;
  }

  // Allow if any allowed role matches
  if (permission.AllowedUsers?.some((role) => userRoles.includes(role))) {
    return true;
  }

  return false;
}
